<template>
    <div class="business">
        <Header active="business"></Header>
        <el-row class="banner" type="flex" align="middle">
            <el-col :span="2"></el-col>
            <el-col :span="4">
                <span class="business-title">解决方案</span>
            </el-col>
        </el-row>
        <el-row class="business-body">

            <el-row class="spacing-up">
                <h1>解决方案</h1>
            </el-row>
            <el-row>
                <el-row class="icon-container">
                    <el-col :span="2" class="business-icon"></el-col>
                    <el-col :span="4" class="business-icon" :class="{ 'business-icon-selected': isSelected(1) }">
                        <div @click="selectedIcon = 1">
                            <!--<i class="el-icon-thirdComputer" ></i>-->
                            <img v-if="!isSelected(1)" class="solution-title-img"
                                src="../../assets/imgs/business/sanhetongyun1.png">
                            <img v-if="isSelected(1)" class="solution-title-img"
                                src="../../assets/imgs/business/sanhetongyun2.png">
                        </div>
                        <div @click="selectedIcon = 1" class="solution-title-text">
                            <span>三合通云</span>
                        </div>
                    </el-col>

                    <el-col :span="4" class="business-icon" :class="{ 'business-icon-selected': isSelected(2) }">
                        <div @click="selectedIcon = 2">
                            <!--<i class="el-icon-thirdzhinengzhuangbei" ></i>-->
                            <img v-if="!isSelected(2)" class="solution-title-img"
                                src="../../assets/imgs/business/智慧农业1.png">
                            <img v-if="isSelected(2)" class="solution-title-img"
                                src="../../assets/imgs/business/智慧农业2.png">
                        </div>
                        <div @click="selectedIcon = 2" class="solution-title-text">
                            <span>智慧农业</span>
                        </div>
                    </el-col>

                    <el-col :span="4" class="business-icon" :class="{ 'business-icon-selected': isSelected(3) }">
                        <div @click="selectedIcon = 3">
                            <!--<i class="el-icon-thirdgongyede-" ></i>-->
                            <img v-if="!isSelected(3)" class="solution-title-img"
                                src="../../assets/imgs/business/智能装备1.png">
                            <img v-if="isSelected(3)" class="solution-title-img"
                                src="../../assets/imgs/business/智能装备2.png">
                        </div>
                        <div @click="selectedIcon = 3" class="solution-title-text">
                            <span>智能装备</span>
                        </div>
                    </el-col>
                    <el-col :span="4" class="business-icon" :class="{ 'business-icon-selected': isSelected(4) }">
                        <div @click="selectedIcon = 4">
                            <!--<i class="el-icon-thirdgongyesheji" ></i>-->
                            <img v-if="!isSelected(4)" class="solution-title-img"
                                src="../../assets/imgs/business/智慧城市1.png">
                            <img v-if="isSelected(4)" class="solution-title-img"
                                src="../../assets/imgs/business/智慧城市2.png">
                        </div>
                        <div @click="selectedIcon = 4" class="solution-title-text">
                            <span>智慧城市</span>
                        </div>
                    </el-col>
                    <el-col :span="4" class="business-icon" :class="{ 'business-icon-selected': isSelected(5) }">
                        <div @click="selectedIcon = 5">
                            <!--<i class="el-icon-thirdgongyesheji" ></i>-->
                            <img v-if="!isSelected(5)" class="solution-title-img"
                                src="../../assets/imgs/business/合作1.png">
                            <img v-if="isSelected(5)" class="solution-title-img"
                                src="../../assets/imgs/business/合作2.png">
                        </div>
                        <div @click="selectedIcon = 5" class="solution-title-text">
                            <span>合作解决方案</span>
                        </div>
                    </el-col>
                    <el-col :span="2" class="business-icon"></el-col>
                </el-row>

                <el-row class="solution-container" v-if="isSelected(1)">
                    <el-col :span="12" class="solution-item solution-item-text-left">

                        <div class="corner-rigth"></div>
                        <el-row class="solution-item-margin">
                            <h1>三合通云</h1>
                        </el-row>
                        <el-row class="solution-item-margin">
                            <p class="solution-item-p">
                                三合通云：拥有完备的云基础架构，将云计算、物联网、大数据、人工智能、5G、北斗等新技术与智慧农业、智能装备和智慧旅游等智慧产业深度融合，搭建三产融合大数据平台，促进一、二、三产业形成高附加值闭环数据链条，为用户精准决策提供服务。
                            </p>
                        </el-row>
                    </el-col>
                    <el-col :span="12" class="solution-item">
                        <el-carousel height="350px">
                            <el-carousel-item v-for="item in shtybannerList" v-bind:key="item.id">
                                <img class="banner-img" :src="item.img" v-bind:class="{ 'pointer': item.clickable }"
                                    @click="onBannerClick(item)" />
                            </el-carousel-item>
                        </el-carousel>
                    </el-col>
                </el-row>
            </el-row>

            <el-row class="solution-container" v-if="isSelected(2)">
                <el-col :span="12" class="solution-item solution-item-text-left">

                    <div class="corner-rigth"></div>
                    <el-row class="solution-item-margin">
                        <h1>生态无人农场</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p class="solution-item-p">
                            是现代农艺和农机装备、绿色植保技术、无人机、机器人、人工智能、物联网、大数据、云计算、3S、5G、
                            北斗等高新技术集成的成果，将依托各种传感器节点和网络，通过天、地、空一体化信息监测系统获取农情信息，
                            采用地空一体化智能农业机器人和农业装备等协同作业，实现农业生产环境的智能感知、智能分析、智能决策、
                            智能预警等功能，达到绿色生态农业生产的精准化种植，可视化管理、智能化操控和生态化保护，打造可复制易推广的
                            绿色生态、高效环保的循环无人农场新模式。
                        </p>
                    </el-row>
                </el-col>
                <el-col :span="12" class="solution-item">
                    <el-carousel height="350px">
                        <el-carousel-item v-for="item in list2" v-bind:key="item.id">
                            <img class="banner-img" :src="item.img" v-bind:class="{ 'pointer': item.clickable }"
                                @click="onBannerClick(item)" />
                        </el-carousel-item>
                    </el-carousel>
                    <!-- <img src="https://www.ccsht.cn/resources/static/images/stwrnc1.png" /> -->
                </el-col>
            </el-row>
            <el-row class="solution-container" v-if="isSelected(2)">
                <el-col :span="12" class="solution-item">
                    <!-- <img src="https://www.ccsht.cn/resources/static/images/stwrncyddn1.png" /> -->
                    <el-carousel height="350px">
                        <el-carousel-item v-for="item in list3" v-bind:key="item.id">
                            <img class="banner-img" :src="item.img" v-bind:class="{ 'pointer': item.clickable }"
                                @click="onBannerClick(item)" />
                        </el-carousel-item>
                    </el-carousel>
                </el-col>
                <el-col :span="12" class="solution-item solution-item-text-right">

                    <div class="corner-left"></div>
                    <el-row class="solution-item-margin">
                        <h1>生态无人农场云端大脑</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p class="solution-item-p">
                            由山东理工大学生态无人农场研究院和三合通科技共同开发的应用服务平台，该平台充分利用大数据、云计算、AI识别、
                            3S技术和区块链技术，通过农场罗盘、数据驾驶舱、智能监测、智能决策、智能作业、智能管理、模型库、智慧科研、
                            智慧溯源、产业链赋能服务等功能模块，实现生态无人农场的数字化、联网化、智能化、无人化管理，为打造精准、无人、
                            高效、低成本和绿色环保的智慧农业新模式提供一体化管理平台。
                        </p>
                    </el-row>
                </el-col>
            </el-row>

            <el-row class="solution-container" v-if="isSelected(3)">
                <el-col :span="12" class="solution-item solution-item-text-left">

                    <div class="corner-rigth"></div>
                    <el-row class="solution-item-margin">
                        <h1>智能农机装备整体解决方案</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p class="solution-item-p">
                            公司具有专业的智能装备研发团队，能够提供从线控底盘、线控改制、自动驾驶算法、高精度地图构建、自动驾驶零部件、
                            自动驾驶整机端到端一体化解决方案。具体包括农机无人驾驶系统、农机辅助驾驶系统和农业机器人系统。
                        </p>
                    </el-row>
                </el-col>
                <el-col :span="12" class="solution-item">
                    <img src="https://www.ccsht.cn/resources/static/images/znzbztjjfa1.png" />
                </el-col>
            </el-row>
            <el-row class="solution-container" v-if="isSelected(3)">
                <el-col :span="12" class="solution-item">
                    <!-- <img src="https://www.ccsht.cn/resources/static/images/znzbykpt1.png" /> -->
                    <el-carousel height="350px">
                        <el-carousel-item v-for="item in list4" v-bind:key="item.id">
                            <img class="banner-img" :src="item.img" v-bind:class="{ 'pointer': item.clickable }"
                                @click="onBannerClick(item)" />
                        </el-carousel-item>
                    </el-carousel>
                </el-col>
                <el-col :span="12" class="solution-item solution-item-text-right">

                    <div class="corner-left"></div>
                    <el-row class="solution-item-margin">
                        <h1>智能装备云控平台</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p class="solution-item-p">
                            为生态无人农场地空一体化农业机器人、无人机和智能农机装备等协同作业提供规范、可靠的服务管理支撑，保证
                            无人机、农业机器人和智能农机等智能装备的安全可控。
                        </p>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="solution-container" v-if="isSelected(3)">
                <el-col :span="12" class="solution-item solution-item-text-left">

                    <div class="corner-rigth"></div>
                    <el-row class="solution-item-margin">
                        <h1>智能网联农机</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p class="solution-item-p">
                            智能网联农机在云端大脑的操控下根据农艺处方生成不同模式进行自主作业。可实现智能识别、自主决策、自主作业等动作并对各类农机具进行自动操控。
                        </p>
                    </el-row>
                </el-col>
                <el-col :span="12" class="solution-item">
                    <img src="https://www.ccsht.cn/resources/static/images/znwlnj1.png" />
                </el-col>
            </el-row>
            <el-row class="solution-container" v-if="isSelected(3)">
                <el-col :span="12" class="solution-item">
                    <!-- <img src="https://www.ccsht.cn/resources/static/images/nyjqr1.png" /> -->
                    <el-carousel height="350px">
                        <el-carousel-item v-for="item in list5" v-bind:key="item.id">
                            <img class="banner-img" :src="item.img" v-bind:class="{ 'pointer': item.clickable }"
                                @click="onBannerClick(item)" />
                        </el-carousel-item>
                    </el-carousel>
                </el-col>
                <el-col :span="12" class="solution-item solution-item-text-right">

                    <div class="corner-left"></div>
                    <el-row class="solution-item-margin">
                        <h1>农机无人驾驶系统</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p class="solution-item-p">
                            能够接收云端下发的指令并向云端上传无人农机工作状态信息，实现云端与无人驾驶农机的实时交互管控，从而达到无人驾驶系统功能。
                        </p>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="solution-container" v-if="isSelected(3)">
                <el-col :span="12" class="solution-item solution-item-text-left">

                    <div class="corner-rigth"></div>
                    <el-row class="solution-item-margin">
                        <h1>智能环保装备</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p class="solution-item-p">
                            智能生态循环利用系列产品-生物质热解处理器以及无动力粪污（有机垃圾）离子矿化处理器，遵循了对自然资源
                            （畜禽粪污和有机垃圾）-清洁生产-日清日洁-绿色消费-再生能源的生态模式，在实现畜牧养殖业粪污日清日洁、
                            以废治废、循环利用的同时，可降低养殖成本、增加养殖户的收入。

                        </p>
                    </el-row>
                </el-col>
                <el-col :span="12" class="solution-item">
                    <!-- <img src="https://www.ccsht.cn/resources/static/images/znhbzb1.png" /> -->
                    <el-carousel height="350px">
                        <el-carousel-item v-for="item in list6" v-bind:key="item.id">
                            <img class="banner-img" :src="item.img" v-bind:class="{ 'pointer': item.clickable }"
                                @click="onBannerClick(item)" />
                        </el-carousel-item>
                    </el-carousel>
                </el-col>
            </el-row>

            <el-row class="solution-container" v-if="isSelected(4)">
                <el-col :span="12" class="solution-item solution-item-text-left">

                    <div class="corner-rigth"></div>
                    <el-row class="solution-item-margin">
                        <h1>十四五规划平台</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p class="solution-item-p">
                            “十四五”规划全生命周期数字化服务云平台包括规划评估中枢、产业数字地图、重大项目驾驶舱、重点任务监控台
                            和规划管理服务台五大模块，可有效促进政府部门的信息资源互联共享，提高政府宏观把握能力和科学决策能力，
                            实现十四五规划全生命周期的数字化管理。
                        </p>
                    </el-row>
                </el-col>
                <el-col :span="12" class="solution-item">
                    <img src="https://www.ccsht.cn/resources/static/images/sswghpt1.png" />
                </el-col>
            </el-row>
            <el-row class="solution-container" v-if="isSelected(4)">
                <el-col :span="12" class="solution-item">
                    <img src="https://www.ccsht.cn/resources/static/images/zhnycn1.png" />
                </el-col>
                <el-col :span="12" class="solution-item solution-item-text-right">

                    <div class="corner-left"></div>
                    <el-row class="solution-item-margin">
                        <h1>智慧农业超脑</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p class="solution-item-p">
                            通过采集环境及作物监测设备数据、智能网联农机作业数据、农业全过程作业数据，建立数据分析模型，给
                            农业管理部门和农业经营主体提供精准有效的服务，为城市大脑提供智慧农业应用的监管和决策数据。
                        </p>
                    </el-row>
                </el-col>
            </el-row>

            <!-- <el-row class="spacing-up">
                <h1>合作解决方案</h1>
            </el-row> -->

            <el-row class="solution-container" v-if="isSelected(5)">
                <el-col :span="12" class="solution-item">
                    <img
                        src="https://www.ccsht.cn/resources/static/images/06%E7%A7%91%E5%A4%A7%E8%AE%AF%E9%A3%9E.jpg" />
                </el-col>
                <el-col :span="12" class="solution-item solution-item-text-right">

                    <div class="corner-left"></div>
                    <el-row class="solution-item-margin">
                        <h1>科大讯飞</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p>
                            三合通科技的战略投资合作伙伴之一，科大讯飞专业从事智能语音及语言技术研究、软件及芯片产品开发、语音信息服务及电子政务系统集成等
                            。在语音合成、语音识别、口语评测、语言翻译、声纹识别、人脸识别、自然语言处理等智能语音与人工智能核心技术上代表国际先进水平。
                        </p>
                    </el-row>
                </el-col>
            </el-row>

            <el-row class="solution-container" v-if="isSelected(5)">
                <el-col :span="12" class="solution-item solution-item-text-left">

                    <div class="corner-rigth"></div>
                    <el-row class="solution-item-margin">
                        <h1>北京百分点</h1>
                    </el-row>
                    <el-row class="solution-item-margin">
                        <p>
                            三合通科技的战略投资合作伙伴之一，是国内大数据公司第一梯队的龙头企业，拥有完整的大数据和认知智能产品线，以及行业智能决策应用产品。目前已服务国内外10,000+企业与政府客户，致力于推进数据到知识再到智能决策的演进。
                        </p>
                    </el-row>
                </el-col>
                <el-col :span="12" class="solution-item">
                    <img
                        src="https://www.ccsht.cn/resources/static/images/07%E5%8C%97%E4%BA%AC%E7%99%BE%E5%88%86%E7%82%B9.jpg" />
                </el-col>
            </el-row>

            <el-row class="bottom"></el-row>

        </el-row>

        <Footer></Footer>
    </div>
</template>

<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import { global } from "@/utils/global";
export default {
    name: "PCBusiness",
    components: { Header, Footer },
    data() {
        return {
            list2: [
                {
                    id: 1,
                    img: require('@/assets/imgs/business/zh1.png'),
                    clickable: false
                },
                {
                    id: 2,
                    img: require('@/assets/imgs/business/zh2.png'),
                    clickable: false
                },
                {
                    id: 3,
                    img: require('@/assets/imgs/business/zh3.png'),
                    clickable: false
                },
                {
                    id: 4,
                    img: require('@/assets/imgs/business/zh4.png'),
                    clickable: false
                },
            ],
            list3: [
                {
                    id: 1,
                    img: 'https://www.ccsht.cn/resources/static/images/stwrncyddn1.png',
                    clickable: false
                },
                {
                    id: 2,
                    img: require('@/assets/imgs/business/zh7.png'),
                    clickable: false
                },
                {
                    id: 3,
                    img: require('@/assets/imgs/business/zh8.png'),
                    clickable: false
                },
            ],
            list4: [
                {
                    id: 1,
                    img: 'https://www.ccsht.cn/resources/static/images/znzbykpt1.png',
                    clickable: false
                },
                {
                    id: 2,
                    img: require('@/assets/imgs/business/zb1.png'),
                    clickable: false
                },
                {
                    id: 3,
                    img: require('@/assets/imgs/business/zb2.png'),
                    clickable: false
                },
                {
                    id: 4,
                    img: require('@/assets/imgs/business/zb3.png'),
                    clickable: false
                },
                {
                    id: 5,
                    img: require('@/assets/imgs/business/zb4.png'),
                    clickable: false
                },
                {
                    id: 6,
                    img: require('@/assets/imgs/business/zb5.png'),
                    clickable: false
                },
            ],
            list5: [
                {
                    id: 1,
                    img: ' https://www.ccsht.cn/resources/static/images/nyjqr1.png',
                    clickable: false
                },
                {
                    id: 2,
                    img: require('@/assets/imgs/business/ww1.jpg'),
                    clickable: false
                },
                // {
                //     id: 3,
                //     img: require('@/assets/imgs/business/wr2.png'),
                //     clickable: false
                // },
                // {
                //     id: 4,
                //     img: require('@/assets/imgs/business/wr3.png'),
                //     clickable: false
                // },
                // {
                //     id: 5,
                //     img: require('@/assets/imgs/business/wr4.png'),
                //     clickable: false
                // },
                // {
                //     id: 7,
                //     img: require('@/assets/imgs/business/wr6.png'),
                //     clickable: false
                // },

            ],
            list6:[
            {
                    id: 1,
                    img: 'https://www.ccsht.cn/resources/static/images/znhbzb1.png',
                    clickable: false
                },
                {
                    id: 2,
                    img: require('@/assets/imgs/business/ee1.jpg'),
                    clickable: false
                },
                {
                    id: 3,
                    img: require('@/assets/imgs/business/ee2.jpg'),
                    clickable: false
                },
            ],
            selectedIcon: 1,
            shtybannerList: [
                {
                    id: 0,
                    img: `${global.RESOURCE_PREFIX}/images/sanhetongyun1.png`,
                    clickable: false
                },
                {
                    id: 1,
                    img: `${global.RESOURCE_PREFIX}/images/sanhetongyun2.png`,
                    clickable: false
                }
            ]
        }
    },
    mounted() {
        if (this.$route.query && this.$route.query.businessName) {
            const businessName = this.$route.query.businessName;
            const numberMap = {
                data: 4,
                equipment: 6,
                manufacture: 7,
                advisory: 1,
                integrated: 2,
                software: 5,
                application: 3,
                industry: 8
            };
            this.selectedIcon = numberMap[businessName];
        }
    },
    methods: {
        isSelected(index) {
            return this.selectedIcon === index;
        }
    }
}
</script>

<style scoped>
.business {
    height: 100%;
    width: 100%;
}

.banner {
    height: 300px;
    width: 100%;
    background: url("../../assets/imgs/business/bg.jpg") no-repeat;
    background-size: 100% 100%;
}

.business-title {
    font-size: 24px;
    color: #ffffff;
    margin-top: 100px;
}

.business-icon {
    text-align: center;
    height: 120px;
}

.business-icon i {
    font-size: 50px;
    /*height: 90px;*/
}

.icon-container {
    /* margin: 0 10%; */
}

.business-icon.business-icon-selected {
    /*border-bottom: 5px solid #ff4e00;*/
}

.business-icon.business-icon-selected i {
    color: #ff4e00;
}

.business-content {
    width: 100%;
    height: 400px;
    /*background: url("../../assets/imgs/home/city.jpg") no-repeat;*/
    background: #f0f0f0;
    background-size: 100% 100%;
    /*color: #000000;*/
}

.business-text-container {
    height: 100%;
    margin-left: 20%;
    margin-right: 10%;
    text-align: left;
    padding: 30px 0;
}

.business-button {
    width: 120px;
}

.business-title {
    font-size: 36px;
}

.business-blue {
    color: #409eff;
}

.business-text {
    font-size: 16px;
    text-align: left;
    padding-left: 60px;
}

.business-img {
    width: 400px;
    height: auto;
}

.business-item-title {
    color: #ff4e00;
}

.corner {
    width: 0;
    height: 0;
    border-left: 40px solid transparent;
    border-right: 40px solid transparent;
    border-top: 50px solid #ffffff;
    z-index: 100;
    position: relative;
    margin: 0 auto;
}

.solution-container {
    width: 100%;
    height: 350px;
}

.solution-item {
    height: 100%;
}

.solution-item-text-right {
    text-align: left;
    /*padding: 0 60px;*/
}

.solution-item-text-left {
    text-align: left;
    /*padding: 0 60px;*/
}

.solution-item img {
    width: 100%;
    height: 350px;
}

.corner-left {
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-right: 30px solid #fff;
    border-bottom: 20px solid transparent;
    z-index: 100;
    position: relative;
    left: -30px;
    top: 140px;
    float: left;
}

.corner-rigth {
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-left: 30px solid #fff;
    border-bottom: 20px solid transparent;
    z-index: 100;
    position: relative;
    right: -30px;
    top: 140px;
    float: right;
}

.solution-item-margin {
    margin-left: 60px;
    margin-right: 60px;
}

.solution-item-margin h1 {
    margin-top: 40px;
}

.solution-item.solution-item-text-right:hover {
    background: #ff4e00;
    color: #ffffff;
}

.solution-item.solution-item-text-left:hover {
    background: #ff4e00;
    color: #ffffff;
}

.solution-item.solution-item-text-right:hover .business-item-title {
    /*background: #ff4e00;*/
    color: #ffffff;
}

.solution-item.solution-item-text-left:hover .business-item-title {
    /*background: #ff4e00;*/
    color: #ffffff;
}

.solution-item.solution-item-text-right:hover .corner-left {
    border-right: 30px solid #ff4e00;
}

.solution-item.solution-item-text-left:hover .corner-rigth {
    border-left: 30px solid #ff4e00;
}

.bottom {
    height: 150px;
    width: 100%;
    background: #ffffff;
}

.business-body {
    color: #505050;
    font-size: 16px;
    line-height: 30px;
}

.parter-row {
    height: 30%;
    width: 100%;
}

.partner-item {}

.parter-item img {
    height: 60px;
    width: 180px;
}

.parter-text {
    color: #ffffff;
    font-size: 24px;
}

.spacing-up {
    margin-top: 60px;
    margin-bottom: 20px;
}

.solution-title-img {
    height: 60px;
}

.solution-title-text {
    margin-top: 10px;
}
</style>
